function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIos = function SvgShareIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.673 8.663h1.335a1.335 1.335 0 0 1 1.335 1.335v10.68a1.335 1.335 0 0 1-1.335 1.334H5.993a1.335 1.335 0 0 1-1.335-1.335V9.997a1.335 1.335 0 0 1 1.335-1.334h1.335M12 1.987v9.346M8.663 5.325 12 1.987l3.338 3.338"
  }));
};
export default SvgShareIos;